import { render, staticRenderFns } from "./ProjectsWordclouds.vue?vue&type=template&id=49a06325&scoped=true"
import script from "./ProjectsWordclouds.vue?vue&type=script&lang=js"
export * from "./ProjectsWordclouds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a06325",
  null
  
)

export default component.exports